import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import { formatPrice } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { useSiteSettings } from "@/context/SiteSettingsContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const { isPrelaunch } = useSiteSettings();
  const inStock = product.stock > 0;

  const onAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isPrelaunch) {
      toast.info("Online ordering opens soon", {
        description: "Contact sales@interstate-pc.com for inquiries.",
      });
      return;
    }
    addItem(product, 1);
    toast.success(`Added to cart: ${product.name}`, {
      description: formatPrice(product.price),
    });
  };

  return (
    <Link to={`/product/${product.id}`} data-testid={`product-card-${product.id}`}
      className="card-hover group relative flex flex-col bg-[#0a0a0c] border border-zinc-800 rounded-sm overflow-hidden">
      <div className="aspect-square bg-[#050505] border-b border-zinc-800 relative overflow-hidden">
        <img src={product.image} alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy" />
        {product.featured && (
          <span className="absolute top-2 left-2 font-mono text-[10px] tracking-widest bg-[#FF5C00] text-black px-2 py-1 rounded-sm">
            FEATURED
          </span>
        )}
        {isPrelaunch && (
          <span className="absolute top-2 right-2 font-mono text-[10px] tracking-widest bg-yellow-500/15 text-yellow-300 border border-yellow-500/40 px-2 py-1 rounded-sm">
            PREVIEW
          </span>
        )}
      </div>
      <div className="p-4 flex-1 flex flex-col">
        <div className="font-mono text-[10px] tracking-widest text-[#00F0FF] uppercase mb-1">{product.brand}</div>
        <div className="font-display font-semibold text-white text-sm leading-snug line-clamp-2 min-h-[2.5rem]">
          {product.name}
        </div>
        <div className="mt-auto pt-4 flex items-end justify-between gap-2">
          <div>
            <div className="font-mono text-xl font-bold text-white">{formatPrice(product.price)}</div>
            {isPrelaunch && (
              <div className="font-mono text-[10px] text-zinc-500 mt-0.5">PREVIEW PRICING</div>
            )}
            <div className="font-mono text-[10px] mt-1 flex items-center gap-1 text-yellow-400/90"
                 data-testid={`availability-${product.id}`}>
              <span className="w-1.5 h-1.5 rounded-full bg-yellow-400/80" />
              {isPrelaunch ? "AVAILABILITY AT LAUNCH" : (inStock ? "IN STOCK" : "OUT OF STOCK")}
            </div>
          </div>
          <Button data-testid={`add-to-cart-${product.id}`}
            onClick={onAdd} disabled={isPrelaunch || !inStock} size="sm"
            className="bg-[#FF5C00] hover:bg-[#FF7A33] text-white rounded-sm font-mono text-[10px] tracking-wider active:scale-95 disabled:opacity-40">
            <Zap className="w-3.5 h-3.5 mr-1" />{isPrelaunch ? "COMING SOON" : "ADD"}
          </Button>
        </div>
      </div>
    </Link>
  );
}
